export const PREFIX = 'cn-ui-m';
